import React from "react";

const ServiceCard = ({ webp, fallback, alt, title, children }) => (
  <div className="flex flex-col md:flex-row items-stretch bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow overflow-hidden">
    <div className="md:w-2/5 flex-shrink-0">
      <picture>
        <source srcSet={webp} type="image/webp" />
        <img
          src={fallback}
          alt={alt}
          className="w-full h-52 object-cover"
          loading="lazy"
        />
      </picture>
    </div>
    <div className="md:w-3/5 p-6 flex flex-col justify-center">
      <h3 className="text-xl font-bold text-orange-500 mb-3">{title}</h3>
      {children}
    </div>
  </div>
);

const Services = () => {
  return (
    <section id="section3" className="bg-orange-500 py-16">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-white mb-2">
          Nuestros Servicios
        </h2>
        <div className="mx-auto mb-10 w-12 h-1 bg-white/60 rounded"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ServiceCard
            webp="/images/slide1.webp"
            fallback="/images/slide1.jpg"
            alt="Limpieza de Oficinas"
            title="Limpieza Profunda"
          >
            <p className="text-gray-600 leading-relaxed">
              Limpieza profunda de casa, departamento, negocio u oficina en el
              momento que lo requieras.
            </p>
          </ServiceCard>

          <ServiceCard
            webp="/images/slide5.webp"
            fallback="/images/slide5.jpg"
            alt="Mantenimiento"
            title="Mantenimiento"
          >
            <ul className="space-y-1 text-gray-600">
              {["Electricidad", "Plomería", "Pintura", "Carpintería", "Albañilería"].map((item) => (
                <li key={item} className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-orange-400 flex-shrink-0"></span>
                  {item}
                </li>
              ))}
            </ul>
          </ServiceCard>

          <ServiceCard
            webp="/images/imagen5.webp"
            fallback="/images/imagen5.jpg"
            alt="Limpieza de Comercios"
            title="Soluciones Integrales"
          >
            <p className="text-gray-600 leading-relaxed">
              Ofrecemos soluciones integrales de limpieza para tu empresa, casa
              o negocio.
            </p>
          </ServiceCard>
        </div>
      </div>
    </section>
  );
};

export default Services;
